import { useState, useContext } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import Layout from '../components/Layout';
import Map from '../components/Map';
import ListadoZonas from '../components/ListadoZonas';
import ListadoPedidos from '../components/ListadoPedidos';
import ListadoProductosPedidos from '../components/ListadoProductosPedidos';


const Zonas = () => {
    const [tab, setTab] = useState(0)
    return (
        <Layout
            pagina={"Zonas"}
        >
            <h1 className="mt-10 mb-5 text-gray-600 text-3xl text-center">Zonas</h1>
            <div className='w-full mt-2 bg-white'>
                <ListadoZonas />
            </div>

        </Layout>
    )
}

export default Zonas